import React from "react";
import { ModuleRouter } from "src/components/molecules";
import { AuthRoute } from "./auth.routes";

export function AuthModule() {
  console.log("AuthModule");

  return (
    <>
      {AuthRoute.subRoutes && (
        <ModuleRouter subRoutes={AuthRoute.subRoutes} path={AuthRoute.path} />
      )}
    </>
  );
}
